import React from "react";
import { GEOLOCATION_TO_LABEL } from "../../geolocationmenuitem/GeolocationMenuItem";
import { TooltipIcon } from "../../../../../components";
import { enums } from "../../../../../shim/jsbridge";
import { transformPlatformSelectionValues } from "../../../../../utils";
import { RLCSConfigurationProps } from "../../../@types/rldynamicanalysis";

const RLCSConfiguration: React.FC<RLCSConfigurationProps> = ({
  configuration,
  platform,
  geolocation,
  locale
}) => {
  const locationDisplay = geolocation
    ? GEOLOCATION_TO_LABEL[geolocation]
    : GEOLOCATION_TO_LABEL[enums.geolocations.US];

  const platformKey = Object.keys(enums.platforms).find(
    key =>
      enums.platforms[key] === (platform === "macos11" ? "macos_11" : platform)
  );
  const platformDisplay = platform
    ? transformPlatformSelectionValues(platformKey)
    : "Unknown platform";

  return (
    <div className="flex align-center flex-gap-2">
      <span>{`${platformDisplay}, ${locationDisplay}, ${
        locale ?? enums.locales.EN_US
      }`}</span>
      <TooltipIcon
        icon="info-circle"
        message={configuration}
        data-testid="rlcs_configuration_info"
      />
    </div>
  );
};

export default RLCSConfiguration;
